// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"48":"b789dd09","491":"dbb5ca5c","655":"229179b1"}[chunkId] + ".js";
};